import * as i0 from '@angular/core';
import { Component, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@ionic/angular';
import { IonicModule } from '@ionic/angular';

class InfoLineComponent {
    /**
     * The icon url (local or hosted)
     */
    icon;
    /**
     * the position of the icon (top of centered)
     *
     * @default "center"
     */
    align = 'center';
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: InfoLineComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.7", type: InfoLineComponent, selector: "info-line", inputs: { icon: "icon", align: "align" }, ngImport: i0, template: "<div class=\"_info-line\" [ngClass]=\"{'_top': align === 'top'}\">\n\t<ion-icon [src]=\"icon\"></ion-icon>\n\t<div style=\"width: 100%;\">\n\t\t<ng-content></ng-content>\n\t</div>\n</div>\n", styles: [":host ::ng-deep p{margin:0;padding-left:20px;flex-shrink:10;color:#000}._info-line{display:flex;flex-direction:row;align-items:center;margin-bottom:20px}._info-line ion-icon{font-size:20px;flex-shrink:0;color:#000}._info-line div{flex-shrink:10}._info-line._top{align-items:flex-start}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: i2.IonIcon, selector: "ion-icon", inputs: ["color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "sanitize", "size", "src"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: InfoLineComponent, decorators: [{
            type: Component,
            args: [{ selector: 'info-line', template: "<div class=\"_info-line\" [ngClass]=\"{'_top': align === 'top'}\">\n\t<ion-icon [src]=\"icon\"></ion-icon>\n\t<div style=\"width: 100%;\">\n\t\t<ng-content></ng-content>\n\t</div>\n</div>\n", styles: [":host ::ng-deep p{margin:0;padding-left:20px;flex-shrink:10;color:#000}._info-line{display:flex;flex-direction:row;align-items:center;margin-bottom:20px}._info-line ion-icon{font-size:20px;flex-shrink:0;color:#000}._info-line div{flex-shrink:10}._info-line._top{align-items:flex-start}\n"] }]
        }], propDecorators: { icon: [{
                type: Input
            }], align: [{
                type: Input
            }] } });

class InfoLineModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: InfoLineModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.7", ngImport: i0, type: InfoLineModule, declarations: [InfoLineComponent], imports: [CommonModule, IonicModule], exports: [InfoLineComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: InfoLineModule, imports: [CommonModule, IonicModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: InfoLineModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [InfoLineComponent],
                    exports: [InfoLineComponent],
                    imports: [CommonModule, IonicModule],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/*
 * Public API Surface of ngx-info-line
 */

/**
 * Generated bundle index. Do not edit.
 */

export { InfoLineComponent, InfoLineModule };
